"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider.state("author", {
    url: "/author",
    template: require("./author.html"),
    controller: "AuthorController",
    controllerAs: "authorCtrl",
  });
}



// WEBPACK FOOTER //
// ./client/app/author/author.routes.js